import React, { useState, Component } from 'react';
import { ArrowLeftIcon, ZapIcon } from 'lucide-react';
import { TabNav } from './TabNav';
import { StatsBar } from './StatsBar';
import { TeamMemberList } from './TeamMemberList';
import { LoanTable } from './LoanTable';
import { MarkCompleteModal } from './MarkCompleteModal';
import type { Loan } from './LoanRow';
// ── Mock Data ──────────────────────────────────────────────
interface TeamMember {
  id: string;
  name: string;
  pendingCount: number;
  totalLoans: number;
  lastActivity: string;
}
const TEAM_MEMBERS: TeamMember[] = [{
  id: 'cameron',
  name: 'Cameron Liebzeit',
  pendingCount: 7,
  totalLoans: 12,
  lastActivity: '2 hours ago'
}, {
  id: 'luke',
  name: 'Luke Hargis',
  pendingCount: 4,
  totalLoans: 9,
  lastActivity: '5 hours ago'
}, {
  id: 'david',
  name: 'David Karasinski',
  pendingCount: 5,
  totalLoans: 11,
  lastActivity: '1 day ago'
}, {
  id: 'lenardo',
  name: 'Lenardo Gabrail',
  pendingCount: 3,
  totalLoans: 8,
  lastActivity: '3 hours ago'
}, {
  id: 'travis',
  name: 'Travis Gibson',
  pendingCount: 6,
  totalLoans: 10,
  lastActivity: '30 min ago'
}, {
  id: 'ontonio',
  name: 'Ontonio Doha',
  pendingCount: 2,
  totalLoans: 7,
  lastActivity: '1 day ago'
}, {
  id: 'pierre',
  name: 'Pierre Delly',
  pendingCount: 8,
  totalLoans: 14,
  lastActivity: '4 hours ago'
}];
const MEMBER_LOANS: Record<string, Loan[]> = {
  cameron: [{
    id: 'l1',
    borrowerName: 'Alberto Aguirre',
    loanNumber: '1842',
    fundedDate: '09/07/2025',
    loanType: 'FHA',
    rate: '6.125%',
    phone: '(760) 902-2399',
    status: 'pending'
  }, {
    id: 'l2',
    borrowerName: 'Adrian Akee',
    loanNumber: '1256',
    fundedDate: '09/03/2025',
    loanType: 'CONV',
    rate: '7.625%',
    phone: '(310) 488-7464',
    status: 'pending'
  }, {
    id: 'l3',
    borrowerName: 'Scott Ahl',
    loanNumber: '1525',
    fundedDate: '09/02/2025',
    loanType: 'CONV',
    rate: '5.999%',
    phone: '(320) 223-3533',
    status: 'pending'
  }, {
    id: 'l4',
    borrowerName: 'Calvin Ricks',
    loanNumber: '1589',
    fundedDate: '08/27/2025',
    loanType: 'VA',
    rate: '5.249%',
    phone: '(601) 267-7203',
    status: 'pending'
  }, {
    id: 'l5',
    borrowerName: 'Terry Linthicum',
    loanNumber: '1103',
    fundedDate: '08/26/2025',
    loanType: 'FHA',
    rate: '6.124%',
    phone: '(540) 691-3454',
    status: 'pending'
  }, {
    id: 'l6',
    borrowerName: 'Janet Cartmill',
    loanNumber: '1447',
    fundedDate: '08/17/2025',
    loanType: 'FHA',
    rate: '5.999%',
    phone: '(319) 470-3788',
    status: 'pending'
  }, {
    id: 'l7',
    borrowerName: 'Rodney Jones',
    loanNumber: '1298',
    fundedDate: '08/14/2025',
    loanType: 'FHA',
    rate: '5.874%',
    phone: '(513) 869-8058',
    status: 'pending'
  }],
  luke: [{
    id: 'l8',
    borrowerName: 'Maria Santos',
    loanNumber: '1901',
    fundedDate: '09/05/2025',
    loanType: 'FHA',
    rate: '6.250%',
    phone: '(415) 555-0142',
    status: 'pending'
  }, {
    id: 'l9',
    borrowerName: 'James Wilson',
    loanNumber: '1876',
    fundedDate: '09/01/2025',
    loanType: 'CONV',
    rate: '7.125%',
    phone: '(212) 555-0198',
    status: 'pending'
  }, {
    id: 'l10',
    borrowerName: 'Patricia Brown',
    loanNumber: '1834',
    fundedDate: '08/28/2025',
    loanType: 'VA',
    rate: '5.500%',
    phone: '(305) 555-0167',
    status: 'pending'
  }, {
    id: 'l11',
    borrowerName: 'Robert Davis',
    loanNumber: '1799',
    fundedDate: '08/20/2025',
    loanType: 'FHA',
    rate: '6.000%',
    phone: '(713) 555-0134',
    status: 'pending'
  }],
  david: [{
    id: 'l12',
    borrowerName: 'Jennifer Martinez',
    loanNumber: '1922',
    fundedDate: '09/06/2025',
    loanType: 'CONV',
    rate: '7.375%',
    phone: '(602) 555-0189',
    status: 'pending'
  }, {
    id: 'l13',
    borrowerName: 'Michael Johnson',
    loanNumber: '1888',
    fundedDate: '09/02/2025',
    loanType: 'FHA',
    rate: '6.125%',
    phone: '(503) 555-0156',
    status: 'pending'
  }, {
    id: 'l14',
    borrowerName: 'Linda Anderson',
    loanNumber: '1855',
    fundedDate: '08/29/2025',
    loanType: 'VA',
    rate: '5.375%',
    phone: '(206) 555-0123',
    status: 'pending'
  }, {
    id: 'l15',
    borrowerName: 'William Taylor',
    loanNumber: '1812',
    fundedDate: '08/22/2025',
    loanType: 'CONV',
    rate: '7.000%',
    phone: '(312) 555-0145',
    status: 'pending'
  }, {
    id: 'l16',
    borrowerName: 'Elizabeth Thomas',
    loanNumber: '1778',
    fundedDate: '08/15/2025',
    loanType: 'FHA',
    rate: '5.875%',
    phone: '(404) 555-0178',
    status: 'pending'
  }],
  lenardo: [{
    id: 'l17',
    borrowerName: 'David Garcia',
    loanNumber: '1945',
    fundedDate: '09/04/2025',
    loanType: 'FHA',
    rate: '6.250%',
    phone: '(469) 555-0112',
    status: 'pending'
  }, {
    id: 'l18',
    borrowerName: 'Susan Lee',
    loanNumber: '1910',
    fundedDate: '08/30/2025',
    loanType: 'CONV',
    rate: '7.250%',
    phone: '(818) 555-0167',
    status: 'pending'
  }, {
    id: 'l19',
    borrowerName: 'Richard White',
    loanNumber: '1867',
    fundedDate: '08/24/2025',
    loanType: 'VA',
    rate: '5.125%',
    phone: '(919) 555-0134',
    status: 'pending'
  }],
  travis: [{
    id: 'l20',
    borrowerName: 'Karen Harris',
    loanNumber: '1956',
    fundedDate: '09/06/2025',
    loanType: 'CONV',
    rate: '7.500%',
    phone: '(614) 555-0189',
    status: 'pending'
  }, {
    id: 'l21',
    borrowerName: 'Charles Clark',
    loanNumber: '1933',
    fundedDate: '09/03/2025',
    loanType: 'FHA',
    rate: '6.000%',
    phone: '(702) 555-0156',
    status: 'pending'
  }, {
    id: 'l22',
    borrowerName: 'Nancy Lewis',
    loanNumber: '1898',
    fundedDate: '08/31/2025',
    loanType: 'FHA',
    rate: '6.375%',
    phone: '(513) 555-0123',
    status: 'pending'
  }, {
    id: 'l23',
    borrowerName: 'Joseph Robinson',
    loanNumber: '1865',
    fundedDate: '08/25/2025',
    loanType: 'VA',
    rate: '5.375%',
    phone: '(704) 555-0145',
    status: 'pending'
  }, {
    id: 'l24',
    borrowerName: 'Margaret Walker',
    loanNumber: '1832',
    fundedDate: '08/19/2025',
    loanType: 'CONV',
    rate: '7.125%',
    phone: '(216) 555-0178',
    status: 'pending'
  }, {
    id: 'l25',
    borrowerName: 'Thomas Hall',
    loanNumber: '1801',
    fundedDate: '08/12/2025',
    loanType: 'FHA',
    rate: '5.750%',
    phone: '(317) 555-0112',
    status: 'pending'
  }],
  ontonio: [{
    id: 'l26',
    borrowerName: 'Dorothy Allen',
    loanNumber: '1967',
    fundedDate: '09/05/2025',
    loanType: 'FHA',
    rate: '6.125%',
    phone: '(407) 555-0167',
    status: 'pending'
  }, {
    id: 'l27',
    borrowerName: 'Daniel Young',
    loanNumber: '1944',
    fundedDate: '09/01/2025',
    loanType: 'CONV',
    rate: '7.375%',
    phone: '(615) 555-0134',
    status: 'pending'
  }],
  pierre: [{
    id: 'l28',
    borrowerName: 'Sandra King',
    loanNumber: '1978',
    fundedDate: '09/07/2025',
    loanType: 'VA',
    rate: '5.250%',
    phone: '(480) 555-0189',
    status: 'pending'
  }, {
    id: 'l29',
    borrowerName: 'Paul Wright',
    loanNumber: '1955',
    fundedDate: '09/04/2025',
    loanType: 'FHA',
    rate: '6.375%',
    phone: '(303) 555-0156',
    status: 'pending'
  }, {
    id: 'l30',
    borrowerName: 'Betty Lopez',
    loanNumber: '1934',
    fundedDate: '09/02/2025',
    loanType: 'CONV',
    rate: '7.000%',
    phone: '(612) 555-0123',
    status: 'pending'
  }, {
    id: 'l31',
    borrowerName: 'Mark Hill',
    loanNumber: '1911',
    fundedDate: '08/30/2025',
    loanType: 'FHA',
    rate: '6.000%',
    phone: '(502) 555-0145',
    status: 'pending'
  }, {
    id: 'l32',
    borrowerName: 'Helen Scott',
    loanNumber: '1889',
    fundedDate: '08/27/2025',
    loanType: 'VA',
    rate: '5.500%',
    phone: '(804) 555-0178',
    status: 'pending'
  }, {
    id: 'l33',
    borrowerName: 'Steven Green',
    loanNumber: '1866',
    fundedDate: '08/23/2025',
    loanType: 'CONV',
    rate: '7.250%',
    phone: '(901) 555-0112',
    status: 'pending'
  }, {
    id: 'l34',
    borrowerName: 'Donna Adams',
    loanNumber: '1843',
    fundedDate: '08/18/2025',
    loanType: 'FHA',
    rate: '5.875%',
    phone: '(414) 555-0167',
    status: 'pending'
  }, {
    id: 'l35',
    borrowerName: 'Edward Baker',
    loanNumber: '1820',
    fundedDate: '08/13/2025',
    loanType: 'FHA',
    rate: '6.250%',
    phone: '(515) 555-0134',
    status: 'pending'
  }]
};
const MY_LOANS: Loan[] = [{
  id: 'ml1',
  borrowerName: 'Angela Cooper',
  loanNumber: '1990',
  fundedDate: '09/08/2025',
  loanType: 'FHA',
  rate: '6.125%',
  phone: '(972) 555-0189',
  status: 'pending'
}, {
  id: 'ml2',
  borrowerName: 'Kevin Reed',
  loanNumber: '1975',
  fundedDate: '09/05/2025',
  loanType: 'CONV',
  rate: '7.250%',
  phone: '(832) 555-0156',
  status: 'pending'
}, {
  id: 'ml3',
  borrowerName: 'Deborah Morgan',
  loanNumber: '1960',
  fundedDate: '09/03/2025',
  loanType: 'VA',
  rate: '5.375%',
  phone: '(571) 555-0123',
  status: 'pending'
}, {
  id: 'ml4',
  borrowerName: 'Brian Bell',
  loanNumber: '1942',
  fundedDate: '08/29/2025',
  loanType: 'FHA',
  rate: '6.000%',
  phone: '(678) 555-0145',
  status: 'pending'
}, {
  id: 'ml5',
  borrowerName: 'Sharon Murphy',
  loanNumber: '1925',
  fundedDate: '08/25/2025',
  loanType: 'CONV',
  rate: '7.500%',
  phone: '(248) 555-0178',
  status: 'pending'
}];
const ALL_TIME_LOANS: Loan[] = [{
  id: 'at1',
  borrowerName: 'George Phillips',
  loanNumber: '1102',
  fundedDate: '03/15/2025',
  loanType: 'FHA',
  rate: '6.500%',
  phone: '(214) 555-0112',
  status: 'completed',
  completedDate: '03/22/2025',
  followUpNote: 'Borrower confirmed satisfaction with closing process.'
}, {
  id: 'at2',
  borrowerName: 'Ruth Campbell',
  loanNumber: '1089',
  fundedDate: '02/28/2025',
  loanType: 'CONV',
  rate: '7.125%',
  phone: '(469) 555-0167',
  status: 'completed',
  completedDate: '03/10/2025',
  followUpNote: 'Referred two new clients.'
}, {
  id: 'at3',
  borrowerName: 'Frank Parker',
  loanNumber: '1056',
  fundedDate: '01/20/2025',
  loanType: 'VA',
  rate: '5.750%',
  phone: '(817) 555-0134',
  status: 'completed',
  completedDate: '02/01/2025',
  followUpNote: 'Happy with rate, may refinance in 12 months.'
}, {
  id: 'at4',
  borrowerName: 'Carol Evans',
  loanNumber: '1034',
  fundedDate: '12/10/2024',
  loanType: 'FHA',
  rate: '6.250%',
  phone: '(682) 555-0189',
  status: 'completed',
  completedDate: '12/20/2024',
  followUpNote: 'Smooth process, left 5-star review.'
}, {
  id: 'at5',
  borrowerName: 'Larry Edwards',
  loanNumber: '1012',
  fundedDate: '11/05/2024',
  loanType: 'CONV',
  rate: '7.000%',
  phone: '(940) 555-0156',
  status: 'completed',
  completedDate: '11/15/2024',
  followUpNote: 'Interested in HELOC in the future.'
}, {
  id: 'at6',
  borrowerName: 'Judy Collins',
  loanNumber: '998',
  fundedDate: '10/18/2024',
  loanType: 'FHA',
  rate: '6.375%',
  phone: '(903) 555-0123',
  status: 'completed',
  completedDate: '10/28/2024',
  followUpNote: 'No issues reported.'
}];
// ── Component ──────────────────────────────────────────────
type TabId = 'team' | 'myLoans' | 'allTime';
export function FundedLoansFollowUp() {
  const [activeTab, setActiveTab] = useState<TabId>('team');
  const [selectedMemberId, setSelectedMemberId] = useState<string | null>(null);
  const [modalLoan, setModalLoan] = useState<Loan | null>(null);
  // Track loan statuses across all data
  const [completedLoanIds, setCompletedLoanIds] = useState<Set<string>>(new Set());
  const tabs = [{
    id: 'team',
    label: 'My Team',
    count: TEAM_MEMBERS.length
  }, {
    id: 'myLoans',
    label: 'My Funded Follow-Ups',
    count: MY_LOANS.filter(l => !completedLoanIds.has(l.id)).length
  }, {
    id: 'allTime',
    label: 'All-Time Follow-Ups'
  }];
  const selectedMember = TEAM_MEMBERS.find(m => m.id === selectedMemberId);
  function getMemberLoans(memberId: string): Loan[] {
    const loans = MEMBER_LOANS[memberId] || [];
    return loans.map(loan => ({
      ...loan,
      status: completedLoanIds.has(loan.id) ? 'completed' as const : loan.status
    }));
  }
  function getMyLoans(): Loan[] {
    return MY_LOANS.map(loan => ({
      ...loan,
      status: completedLoanIds.has(loan.id) ? 'completed' as const : loan.status
    }));
  }
  function handleMarkComplete(loanId: string, _note: string, _followUpDate: string) {
    setCompletedLoanIds(prev => new Set([...prev, loanId]));
    setModalLoan(null);
  }
  function handleBack() {
    setSelectedMemberId(null);
  }
  function handleTabChange(tabId: string) {
    setActiveTab(tabId as TabId);
    setSelectedMemberId(null);
  }
  // Compute stats
  const totalFunded = Object.values(MEMBER_LOANS).flat().length + MY_LOANS.length;
  const pendingFollowUps = Object.values(MEMBER_LOANS).flat().filter(l => !completedLoanIds.has(l.id) && l.status === 'pending').length + MY_LOANS.filter(l => !completedLoanIds.has(l.id) && l.status === 'pending').length;
  const completedThisMonth = completedLoanIds.size + ALL_TIME_LOANS.filter(l => l.status === 'completed').length;
  const allRates = [...Object.values(MEMBER_LOANS).flat(), ...MY_LOANS].map(l => parseFloat(l.rate.replace('%', '')));
  const avgRate = allRates.length > 0 ? (allRates.reduce((a, b) => a + b, 0) / allRates.length).toFixed(3) + '%' : '0%';
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-2">
        {/* Header */}
        <div className="mb-6" data-id="element-3">
          <div className="flex items-center gap-3 mb-1" data-id="element-4">
            <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-blue-600" data-id="element-5">
              <ZapIcon className="w-5 h-5 text-white" data-id="element-6" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-7">
              Funded Loans Follow-Up
            </h1>
          </div>
          <p className="text-sm text-gray-500 ml-12" data-id="element-8">
            Track and manage post-funding follow-ups for your team
          </p>
        </div>

        {/* Stats */}
        <div className="mb-6" data-id="element-9">
          <StatsBar totalFunded={totalFunded} pendingFollowUps={pendingFollowUps} completedThisMonth={completedThisMonth} avgRate={avgRate} data-id="element-10" />
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm" data-id="element-11">
          <div className="px-5 pt-2" data-id="element-12">
            <TabNav tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} data-id="element-13" />
          </div>

          <div className="p-5" data-id="element-14">
            {/* My Team Tab */}
            {activeTab === 'team' && !selectedMemberId && <TeamMemberList members={TEAM_MEMBERS} onSelectMember={setSelectedMemberId} data-id="element-15" />}

            {/* Team Member Drill-Down */}
            {activeTab === 'team' && selectedMemberId && selectedMember && <div data-id="element-16">
                <div className="flex items-center gap-3 mb-5" data-id="element-17">
                  <button onClick={handleBack} className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" aria-label="Back to team list" data-id="element-18">
                    <ArrowLeftIcon className="w-5 h-5" data-id="element-19" />
                  </button>
                  <div data-id="element-20">
                    <h2 className="text-base font-semibold text-gray-900" data-id="element-21">
                      {selectedMember.name}
                    </h2>
                    <p className="text-xs text-gray-500" data-id="element-22">
                      {getMemberLoans(selectedMemberId).filter(l => l.status === 'pending').length}{' '}
                      pending follow-ups
                    </p>
                  </div>
                </div>
                <LoanTable loans={getMemberLoans(selectedMemberId)} onMarkComplete={loan => setModalLoan(loan)} onView={() => {}} showActions={true} title={`Funded Loans for ${selectedMember.name}`} data-id="element-23" />
              </div>}

            {/* My Funded Follow-Ups Tab */}
            {activeTab === 'myLoans' && <LoanTable loans={getMyLoans()} onMarkComplete={loan => setModalLoan(loan)} onView={() => {}} showActions={true} title="My Funded Follow-Ups" data-id="element-24" />}

            {/* All-Time Follow-Ups Tab */}
            {activeTab === 'allTime' && <LoanTable loans={ALL_TIME_LOANS} onMarkComplete={() => {}} onView={() => {}} showActions={false} title="All-Time Follow-Ups (Completed)" data-id="element-25" />}
          </div>
        </div>
      </div>

      {/* Mark Complete Modal */}
      {modalLoan && <MarkCompleteModal loan={modalLoan} isOpen={!!modalLoan} onClose={() => setModalLoan(null)} onConfirm={handleMarkComplete} data-id="element-26" />}
    </div>;
}